import { trackEvent } from '@patrianna/analytics'
import { openDialog } from '@patrianna/dialog-manager'
import type { OtpModalTriggeredResponse } from '@patrianna/shared-patrianna-types/websocket/response'
import { nextTick } from '@patrianna/shared-utils'

import BannerTile from 'components/BannerTile'
import { serviceDependencies } from 'src/services'
import { useAppDispatch, useAppSelector } from 'src/store/hooks'
import { getUserCommunicationPreferencesSelector } from 'src/store/modules/user/selectors'
import { ImagesDirectory, generateImageUrl } from 'utils/setImageUrl'

function SmsConsent() {
  const dispatch = useAppDispatch()
  const communicationPreferences = useAppSelector(getUserCommunicationPreferencesSelector)

  const onSmsConsentClick = () => {
    nextTick().then(() => {
      trackEvent('sms_banner_click')

      const data = {
        type: 'OtpModalTriggeredRequest',
        source: 'home_page_banner',
        setUpNotifications: true,
      } as const

      serviceDependencies.gateway.emit<OtpModalTriggeredResponse>(data).catch((err) => {
        dispatch(serviceDependencies.errorHandler(err, data))
      })

      openDialog({
        dialogName: 'SMS_CONSENT_DIALOG',
        dialogProps: {
          newPreferences: {
            doNotSendEmails: communicationPreferences.doNotSendEmails,
            doNotSendPushes: communicationPreferences.doNotSendPushes,
            doNotSendSms: false,
            doNotCall: false,
          },
          source: 'home_page_banner',
        },
      })
      trackEvent('sms_popup_appeared')
    })
  }
  const bannerUrl = generateImageUrl('banners/phone-notifications-new/source.png', ImagesDirectory.BANNERS)

  return <BannerTile onClick={onSmsConsentClick} src={bannerUrl} alt='sms consent' dataTest='sms-consent-banner' />
}

export default SmsConsent
